import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/security'

class RoleApi {
  getList(page, size) {
    return axios
      .get(API_URL + '/roles/admin?actualPage=' + page + '&perPage=' + size, {
        headers: authHeader()
      })
      .then(response => {
        return response
      })
  }

  getProfile() {
    return axios
      .get(API_URL + '/_profile', {
        headers: authHeader()
      })
  }

  donwloadManual() {
    return axios
      .get(API_URL + '/_manual', {
        headers: authHeader(),
        responseType: 'blob'
      })
  }
}

export default new RoleApi()
